{
  "name": "atmo-front",
  "version": "0.1.0",
  "private": true,
  "type": "module",
  "scripts": {
    "dev": "vite",
    "serve": "vite",
    "build": "vite build",
    "preview": "vite preview",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "format": "prettier --write . --ignore-path .gitignore --ignore-path .prettierignore",
    "format:check": "prettier --check . --ignore-path .gitignore --ignore-path .prettierignore",
    "i18n:report": "vue-i18n-extract report --vueFiles './src/**/*.?(js|vue)' --languageFiles './src/lang/**/*.json'",
    "prepare": "husky"
  },
  "dependencies": {
    "@bufbuild/protobuf": "2.16.0",
    "@connectrpc/connect": "2.3.0",
    "@connectrpc/connect-web": "2.3.0",
    "@intlify/unplugin-vue-i18n": "11.2.8",
    "@sentry/vue": "8.55.2",
    "@socotec.io/contributors-sdk": "3.0.0",
    "@socotec.io/document-sdk": "16.0.0",
    "@socotec.io/materials-sdk": "2.0.0",
    "@socotec.io/report-generator-sdk": "4.1.0",
    "@socotec.io/socio-grpc-api": "814.0.3",
    "@socotec.io/socio-vue-components": "10.6.2",
    "@socotec.io/user-management-sdk": "4.0.0",
    "@uppy/core": "3.13.1",
    "@uppy/dashboard": "3.9.1",
    "@uppy/drag-drop": "3.1.1",
    "@uppy/progress-bar": "3.1.1",
    "@uppy/vue": "1.1.2",
    "axios": "1.21.0",
    "core-js": "3.51.0",
    "dayjs": "1.11.23",
    "dexie": "3.2.7",
    "lodash": "4.18.1",
    "lodash.clonedeep": "4.5.0",
    "pinia": "3.0.4",
    "plotly.js-dist-min": "3.7.0",
    "snakecase-keys": "5.5.0",
    "unleash-proxy-client": "3.8.2",
    "uuid": "9.0.1",
    "vite-plugin-vuetify": "2.1.3",
    "vue": "3.5.44",
    "vue-i18n": "11.4.18",
    "vue-router": "4.6.4",
    "vue-signature-pad": "3.0.2",
    "vue3-oidc": "1.0.2",
    "vuetify": "3.13.7",
    "vuex": "4.1.0",
    "workbox-window": "7.4.1"
  },
  "devDependencies": {
    "@eslint/js": "9.39.5",
    "@playwright/test": "1.64.1",
    "@sentry/vite-plugin": "5.4.1",
    "@vitejs/plugin-vue": "6.0.10",
    "@vue/eslint-config-prettier": "10.2.0",
    "eslint": "9.39.5",
    "eslint-config-prettier": "10.1.8",
    "eslint-formatter-checkstyle": "9.0.1",
    "eslint-plugin-prettier": "5.5.7",
    "eslint-plugin-unused-imports": "4.4.1",
    "eslint-plugin-vue": "9.33.0",
    "globals": "16.5.0",
    "husky": "9.1.7",
    "lint-staged": "15.5.2",
    "prettier": "3.9.10",
    "sass": "1.107.1",
    "terser": "5.51.2",
    "typescript": "5.9.3",
    "vite": "8.3.5",
    "vite-plugin-pwa": "1.3.0",
    "vite-plugin-vue-devtools": "8.2.1"
  },
  "lint-staged": {
    "*.{js,jsx,vue}": [
      "eslint --fix",
      "prettier --write"
    ]
  },
  "packageManager": "pnpm@10.34.9",
  "gitHooks": {
    "pre-commit": "lint-staged"
  }
}
